import auth from "@/core/middlewares/auth";
import mobile from "@/core/middlewares/mobile";

export default [
    auth,
    mobile
]